import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import { initSearchTracker } from './utils/searchTracker'

// 全局初始化搜索埋点上报：启动定时 flush，并在切页/关页时上报
// （此前只在管理页初始化，导致普通用户/游客的搜索事件只积压在 localStorage 里发不出去）
initSearchTracker()

createApp(App).use(ElementPlus, { locale: zhCn }).use(router).mount('#app')
